/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylist } from 'src/core/themes/luisStylist';

const messages = defineMessages({
    nonTrainedLabel: {
        id: 'analytics.trainingEvaluation.nonTrainedLabel',
        defaultMessage: 'Please train your model to view prediction accuracy.'
    }
});

const { styleComponent } = getStylist('Dashboard');

const Wrapper = styleComponent<IStackProps>(Stack)('Wrapper', theme => ({
    lineHeight: theme.largeLineHeight,
    height: theme.nonTrainedCardHeight,
    letterSpacing: theme.xLargeLetterSpacing
}));

const NonTrainedLabel = styleComponent(LuisText)('Wrapper', { opacity: 0.72 });

/**
 * Renders the state of the non-trained cards for the dashboard page.
 */
export const NonTrainedPlaceholder = () => {
    const { localize } = useLocalization();

    return (
        <Wrapper verticalAlign="center" horizontalAlign="center">
            <NonTrainedLabel>{localize(messages.nonTrainedLabel)}</NonTrainedLabel>
        </Wrapper>
    );
};
